import { ColumnsOverview } from '../components/ColumnsOverview';
import { CanvasView } from '../canvas/components/CanvasView';
import { EditorView } from '../editor/components/EditorView';
import { PLAYGROUND_BOARD_ID } from './playgroundData';
import { LandingBoardView } from './LandingBoardView';
import { LandingOverviewView } from './LandingOverviewView';

export type DemoView = 'roadmap' | 'overview' | 'columns' | 'canvas' | 'editor';

export function LandingDemoContent({ view }: { view: DemoView }) {
  switch (view) {
    case 'roadmap':
      return <LandingBoardView />;
    case 'overview':
      return <LandingOverviewView />;
    case 'columns':
      return (
        <div className="landing-demo-view-scroll">
          <ColumnsOverview />
        </div>
      );
    case 'canvas':
      return (
        <div className="landing-demo-view-fill">
          <CanvasView boardId={PLAYGROUND_BOARD_ID} />
        </div>
      );
    case 'editor':
      return (
        <div className="landing-demo-view-scroll-white">
          <EditorView boardId={PLAYGROUND_BOARD_ID} />
        </div>
      );
  }
}
